import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css'; // Import your CSS

const Sidebar = () => {
  return (
    <div className="sidebar">
      <NavLink to="/dashboard"className={({ isActive }) => (isActive ? "active-link" : "")}>
        <button className="sidebar-button">Dashboard</button>
      </NavLink>
      <NavLink to="/transaction" className={({ isActive }) => (isActive ? "active-link" : "")}>
        <button className="sidebar-button">Transaction</button>
      </NavLink>
     {/*} <NavLink to="/gift-management" activeClassName="active-link">
        <button className="sidebar-button">Gift Management</button>
      </NavLink>
      <NavLink to="/orders" activeClassName="active-link">
        <button className="sidebar-button">Orders</button>
      </NavLink>*/}
      <NavLink to="/reports" className={({ isActive }) => (isActive ? "active-link" : "")}>
  <button className="sidebar-button">Reports</button>
</NavLink>
      <NavLink to="/profile" className={({ isActive }) => (isActive ? "active-link" : "")}>
        <button className="sidebar-button">Profile</button>
      </NavLink>
    </div>
  );
};

export default Sidebar;
